import React, { useEffect, useState } from "react";
import { FormBuilder } from "react-formio";
import axios from "axios";
import "../css/AddTemplate.css";
import "../css/FormList.css";

const EditFormBuilder = ({ formData, isOpen, onClose, onSaved }) => {
  const [formSchema, setFormSchema] = useState({});
  const [formName, setFormName] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (formData) {
      setFormSchema(formData.schema || {});
      setFormName(formData.form_name || "");
    }
  }, [formData]);

  const handleFormChange = (schema) => {
    setFormSchema(schema);
  };

  const handleSave = async () => {
    if (!formData?._id) {
      alert("Invalid form ID");
      return;
    }
    try {
      await axios.put(`${API_URL}/ems/forms/${formData._id}`, {
        form_name: formName,
        schema: formSchema,
      });
      alert("Form updated successfully!");
      onSaved();
      onClose();
    } catch (error) {
      console.error("Error saving form:", error);
      alert("Failed to update form.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content edit-form-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h5 className="modal-title m-0">Edit Form</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Form Name</label>
          <input
            type="text"
            className="form-control"
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
          />
        </div>
        <FormBuilder form={formSchema} onChange={handleFormChange} />
        <div className="d-flex justify-content-end mt-3">
          <button type="button" className="btn btn-secondary me-2" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-warning" onClick={handleSave}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditFormBuilder;
